// CANONICAL COPY: installations\smart-td\content\disciplineProvisions.js (ruling 321 slice 3c, task list section 731). src\data\disciplineProvisions.js
// is its projection, written by scripts\sync-installation.js. An edit made only to the projection is refused by the cycle.
// GENERATED by scripts\gen-discipline-provisions.js from data\YCP_VIOLATION_RULE_MAP.csv - DO NOT EDIT HERE.
// T5 / D-3, D-13 (2026-10-15): every DISC- row of the rule map, verbatim, with its file:line. Regenerate after the
// map changes; the --check (scripts\test-discipline-provisions.mjs) fails while this file and the map disagree.
export const MAP_KEY_BY_AGREEMENT = {
  "Amtrak Yardmaster Agreement (eff. Jan 1, 1983; Labor Relations Printout, Nov 1, 2000)": "AMTRAK-YM-2000-11-01",
  "Conrail Yardmasters Agreement (eff. July 1, 1978)": "CONRAIL-YM-1978",
  "Delaware & Hudson / Canadian Pacific Yardmaster Agreement (codified 2007)": "DH-CP-2007",
  "CSX Yardmaster System Agreement (eff. July 1, 2002)": "CSX-2002",
  "Conrail Mechanical Supervisors Agreement (modifications 1994)": "CONRAIL-MS-1995",
  "BN Yardmaster Agreement": "BN-YM-1994",
  "Metra (NIRC) Yardmaster Agreement (eff. Jan 1, 1984; rev. Sep 1, 2010)": "METRA-NIRC-YM-1984",
  "Soo Line Yardmaster Schedule of Rules (eff. Nov 1, 2005)": "SOO-YM-2005-11-01"
};

export const DISCIPLINE_PROVISIONS = [
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-appeal-limits",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "(d) If the decision is not satisfactory to the yard master, appeal in writing may be taken successively, to the Division Manager-Labor Relations and the Director-Labor Relations, provided such appeals are made in writing within thirty (30) calendar days from the date of previous decision.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:922"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-automatic-withdrawal-for-management-non-appe",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "If management’s representative fails to attend the meeting, the letter of intent to impose discipline will be withdrawn and canceled.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:897"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-certified-mail-notice-of-dismissal",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "In order to facilitate the appeal, a copy of the notice of dismissal will be sent to the General Chairman via Certified U.S. Mail.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:935"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-dismissal-service-on-general-chairman",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "In cases of dismissal, a copy of the decision will be sent to the General Chairman via Certified U.S. Mail, in accordance with the provisions of \"Expedited Handling of Dismissal Cases\", set forth below.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:917"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-hearing-conduct-cross-examination",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "The accused yard master or his duly accredited representative shall be permitted to question witnesses insofar as the interests of the accused yard master are involved.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:907"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-hearing-conduct-right-to-hearing",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "(c) A yard master who has been in the Corporation's service one hundred twenty (120) calendar days or longer and against whom the Corporation has preferred specific charges, in writing, shall not be disqualified, suspended or dismissed without a hearing",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:903"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-hearing-conduct",
  "rule": "RULE 22 — ATTENDING COURT, ETC.",
  "quote": "required to attend court, inquest, or discipline investigation, as a witness for the Corporation, by direction of an officer of the Corporation",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:596"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-holding-out-of-service",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "(b) When a major offense has been committed, a yard master suspected by the Corporation to be guilty thereof, may be held out of service pending hearing and decision.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:901"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE 23 — JURY DUTY",
  "quote": "On any day that an employee is released from jury duty and four or more hours of his work assignment remain, he will immediately inform his supervisor and report for work if advised to do so.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:634"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "(a) In those cases where an employee's offense(s) suggest discipline short of dismissal and the Corporation believes that discipline of an employee is warranted, the employee will be notified in writing with a copy to his duly accredited representative of the intent to discipline him.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:886"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "The notice will advise the employee of the specific offense(s) and the reason(s) for the intended imposition of the discipline.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:888"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-pre-hearing-resolution-meeting",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "Within seven days from receipt of the written intent to discipline, the employee and his duly accredited representative will meet with management’s representative at the employee’s city of employment for the purpose of resolving the matter.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:894"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-record-removal-reinstatement",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "(g) If the original decision or any appeal decision holds that the yard master was unjustly disqualified, suspended, or dismissed, his record will be changed accordingly and he shall be reinstated with seniority rights unimpaired and compensated for wage loss sustained, if any, less the amount earned in other employment.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:945"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-record-removal",
  "rule": "RULE 3 — PROBATIONARY PERIOD",
  "quote": "Applicants shall within one hundred twenty (120) calendar days from date of employment, if requested, have returned to them all documents which have been furnished to the Corporation.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:278"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-remedy-computation",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "compensated for wage loss sustained, if any, less the amount earned in other employment",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:947"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-representation",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "at which he shall be permitted to have a duly accredited representative or representatives of his choosing and witnesses to testify on his behalf.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:905"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-time-limits-30-day-knowledge-rule",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "Letters of intent to impose discipline shall not be issued to an employee for any offense of which the employee's supervisor has had actual knowledge for more than 30 calendar days, except where a civil action or criminal proceeding results from the offense, in which event the letter of intent to impose discipline may be issued within 30 days of the final judgment.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:889"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-time-limits-appeal-decisions",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "The decisions of the Division Manager-Labor Relations and the Director-Labor Relations shall be rendered within thirty (30) days of the date the appeal is heard.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:924"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-time-limits-decision",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "Decision shall be given in writing within thirty (30) calendar days after the close of the hearing to the yard master with copy to the Local Chairman.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:916"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-time-limits-expedited-dismissal-conference",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "2. A conference will be arranged as promptly as possible, but not later than thirty (30) days after the Director-Labor Relations receives the appeal.  The Director-Labor Relations will render a decision within fifteen (15) days after the case is discussed in conference.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:937"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-time-limits-hearing-commencement",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "The hearings shall begin within thirty (30) calendar days from the date of the employee's immediate supervisor's first knowledge of the yard master's involvement.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:909"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-transcript",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "Copy of the hearing transcript shall be given the accused yard master and his duly accredited representative if he was so represented.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:910"
 },
 {
  "key": "AMTRAK-YM-2000-11-01",
  "id": "DISC-unreasonable-refusal-of-extension",
  "rule": "RULE 36 — DISCIPLINE AND APPEALS",
  "quote": "The time limits of this paragraph may be extended by mutual agreement between the yard master or his duly accredited representative and the Corporation which shall not be unreasonably withheld by either party.",
  "cite": "data/agreements/amtrak-ym-2000-11-01.txt:919"
 },
 {
  "key": "BN-YM-1994",
  "id": "DISC-just-cause-challenge-to-roa-removal",
  "rule": "ARTICLE VI — Right of Appointment, paragraph C",
  "quote": "Once a yardmaster, who has established seniority as such, has been assigned to an ROA position and has worked thereon for more than 60 full shifts, if s/he is subsequently removed form the ROA position and another employee is assigned to the ROA position, the employee who is removed may challenge his removal through the formal grievance procedure. To successfully challenge his removal from the ROA position, s/he must show that the carrier's decision to remove him or her from the position was without just cause.",
  "cite": "data/agreements/BN_YM_Memorandum_1994.ocr.txt:257"
 },
 {
  "key": "BN-YM-1994",
  "id": "DISC-just-cause",
  "rule": "ARTICLE VI — Right of Appointment, paragraph C",
  "quote": "It is understood that assignments due to reasons such as reductions and rearrangement of yardmaster positions, assignment of a more qualified yardmaster, reassignment due to declining performance and reassignments to broaden a yardmaster's work experience would constitute just cause. (It is understood that the listing of examples in the preceding sentence is intended to set forth reasons for reassignment which the parties discussed and agreed would constitute just cause for removing a yardmaster from a ROA position and replacing him or her with another employee, and will not be construed to mean or imply that reassignments for reasons not set forth in the examples would be deemed to be lacking just cause for reassignment. )",
  "cite": "data/agreements/BN_YM_Memorandum_1994.ocr.txt:263"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-attendance-policies-separate",
  "rule": "POLICY — SECTION D ATTENDANCE POLICIES SEPARATE",
  "quote": "Conrail’s Attendance Policies are separate from this Policy.",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:108"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-critical-rules-definition",
  "rule": "POLICY — SECTION B TERMINABLE OFFENSES",
  "quote": "Critical Rule violations, as defined in Appendix A",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:99"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-decertification-fra",
  "rule": "POLICY — SECTION A.1 DECERTIFICATION",
  "quote": "When events are covered by the FRA certification regulations, the involved employee/s shall also be subject to the applicable FRA regulations and any other applicable federally mandated revocation periods, in addition to discipline pursuant to this Policy.",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:36"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-just-cause",
  "rule": "POLICY — PREAMBLE",
  "quote": "The severity of the disciplinary action depends upon, among other things, the nature and gravity of the offense and its impact on the organization, and the employee’s work record.",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:26"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-progressive-discipline-progression",
  "rule": "POLICY — SECTION A (PROGRESSION)",
  "quote": "Generally speaking, disciplinary action will consist of the following progression:",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:30"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-record-removal",
  "rule": "POLICY — SECTION A.3 RETENTION PERIOD",
  "quote": "Violations remain active on an employee’s record for thirty-six (36) months from the date of the violation (the “Retention Period”).",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:59"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-record-removal",
  "rule": "POLICY — SECTION A.3 RETENTION PERIOD",
  "quote": "Once a violation’s Retention Period has expired, it will no longer be considered for the purposes of progressive discipline",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:71"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-terminable-offenses-summary-dismissal",
  "rule": "POLICY — SECTION B TERMINABLE OFFENSES",
  "quote": "certain forms of serious misconduct and performance deficiencies may result in removal from service or discharge for a single incident and without prior counseling and/or progressive discipline.",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:86"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-termination-review-approval",
  "rule": "POLICY — SECTION E TERMINATION REVIEW",
  "quote": "All terminations must be reviewed and approved by Human Resources and the Legal Department before being issued to employees.",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:112"
 },
 {
  "key": "CONRAIL-DP-2021",
  "id": "DISC-waiver-procedure",
  "rule": "POLICY — SECTION A.3 RETENTION PERIOD",
  "quote": "If the employee elects to a sign a waiver, the retention period will be reduced to twenty-four (24) months from the date of the violation.",
  "cite": "data/agreements/conrail-discipline-policy-2021.source.txt:60"
 },
 {
  "key": "CONRAIL-MS-1995",
  "id": "DISC-appeal-limits",
  "rule": "Rule 15(D) (Article VI, Section 2 - Discipline Appeals)",
  "quote": "the Senior Director-Labor Relations, provided such appeal is made in writing within thirty (30) calendar days from the date of the notice of discipline.",
  "cite": "data/agreements/ConrailMS_modifications_1994.ocr.txt:94"
 },
 {
  "key": "CONRAIL-MS-1995",
  "id": "DISC-hearing-conduct-right-to-hearing",
  "rule": "Rule 15(B) (1994 schedule)",
  "quote": "shall not be disciplined or dismissed without a hearing at which he shall be permitted to have a representative or representatives of his choosing and witnesses to testify on his behalf.",
  "cite": "data/agreements/ConrailMS_base_1994-05-01.ocr.txt:848"
 },
 {
  "key": "CONRAIL-MS-1995",
  "id": "DISC-holding-out-of-service",
  "rule": "Rule 15(A) (1994 schedule)",
  "quote": "When a major offense has been committed a Foreman suspected by the Company to be guilty thereof may be held out of service pending hearing and decision.",
  "cite": "data/agreements/ConrailMS_base_1994-05-01.ocr.txt:842"
 },
 {
  "key": "CONRAIL-MS-1995",
  "id": "DISC-time-limits-expedited-dismissal-conference",
  "rule": "Rule 14(E) (Article VI, Section 1 - Claims and Grievances)",
  "quote": "meetings dates for appeals of discipline by dismissal and will be made whole for loss of straight-time earnings.",
  "cite": "data/agreements/ConrailMS_modifications_1994.ocr.txt:83"
 },
 {
  "key": "CONRAIL-MS-1995",
  "id": "DISC-time-limits",
  "rule": "Rule 15(B) (1994 schedule)",
  "quote": "The hearings shall begin within thirty (30) calendar days from the date of the Company's first knowledge of the occurrence or offense.",
  "cite": "data/agreements/ConrailMS_base_1994-05-01.ocr.txt:856"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-appeal-limits",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "appeal in writing may be taken successively, to the Manager-Labor Relations and Senior Director-Labor Relations, provided such appeals are made in writing within thirty (30) calendar days from date of previous decision",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1255"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-appeal-limits",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "The decision of the Senior Director-Labor Relations shall be considered final and binding unless within sixty (60) calendar days thereafter he is notified in writing that the decision is not acceptable.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1261"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-appeal-limits",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "Subsequent handling must be instituted within six (6) months from the date of such decision.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1262"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-appeal-limits",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "Appeals not handled in accordance with the provisions of this rule shall be deemed to have been abandoned.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1265"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-hearing-conduct",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "The accused yard master or his duly accredited representative shall be permitted to question witnesses insofar as the interests of the accused yard master are involved.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1240"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-hearing-conduct",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "Copy of the hearing transcript shall be given the accused yard master and his duly accredited representative if he was so represented.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1244"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-held-out-of-service-pending-hearing",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "When a major offense has been committed, a yard master suspected by the Company to be guilty thereof may be held out of service pending hearing and decision.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1225"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-investigation-outside-assigned-hours",
  "rule": "RULE/ARTICLE — RULE NO. 5 — HANDLING OF EMPLOYEES",
  "quote": "masters shall not be disturbed by a call for the purpose of investigation outside of their regular assigned working hours, except in cases of emergency.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1219"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "A yard master who has been in the Company's service sixty (60) calendar days or longer and against whom the Company has preferred specific charges, in writing, shall not be disqualified, suspended or dismissed without a hearing at which he shall be permitted to have a duly accredited representative or representatives of his choosing and witnesses to testify on his behalf.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1230"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE/ARTICLE — RULE NO. 4 — TIME ALLOWANCES",
  "quote": "Any yard master falsely claiming sickness or injury will be subject to discipline.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:898"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-record-removal",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "If the original decision or any appeal decision holds that the yard master was unjustly disqualified, suspended or dismissed, his record will be changed accordingly and he shall be reinstated with seniority rights unimpaired and compensated for wage loss sustained, if any, less the amount earned in other employment.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1268"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-time-limits",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "The hearings shall begin within twenty (20) calendar days from the date of the employee's immediate supervisor's first knowledge of the yard master's involvement.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1242"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-time-limits",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "Decision shall be given in writing within twenty (20) calendar days after the close of the hearing to the yard master with copy to the Division Chairman.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1247"
 },
 {
  "key": "CONRAIL-YM-1978",
  "id": "DISC-time-limits",
  "rule": "RULE/ARTICLE — RULE NO. 6 — DISCIPLINE AND APPEALS",
  "quote": "The time limits of this paragraph may be extended by mutual agreement between the yard master or his duly accredited representative and the Company which shall not be unreasonably withheld by either party.",
  "cite": "data/agreements/conrail-rya-7-1-78.source.txt:1249"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-attendance-counseling-notice-and-pay",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "It was agreed that management had the right to counsel yardmasters about their attendance at any time. The employee and local chairman will be notified to arrange the date and time. However, attendance counseling will be paid at time and one-half unless conducted during the yardmaster's regularly assigned working hours. Yardmasters required to participate in attendance counseling on their rest day or prior to their assigned hours will be paid eight (8) hours at time and one-half. Yardmasters may be held on a continuous time basis at the punitive rate for up to sixty (60) minutes coincidental with end of their tour of duty. Once the sixty (60) minute period has elapsed, the yardmaster will be released or paid eight (8) hours at time and one-half for such counseling.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:4066"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-decision-time-limit",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "(b) A decision shall be rendered within thirty (30) days after completion of investigation, with copy to the General Chairman and charged Yardmaster.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2100"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-hearing-time-limit",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "and hearing will be held within fifteen (15) days following the immediate supervisor's first knowledge of the incident.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2092"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-improper-use-of-the-waiver-track",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "(1) Disposition would result in dismissal from service.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2128"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-improper-withholding-from-service",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "A Yardmaster accused by the Carrier to be guilty of a major offence may be held out of service pending the hearing and decision.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2094"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-make-whole-on-exoneration",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "(d) If the final decision decrees that the charge or charges against the Yardmaster are not sustained, the record shall be cleared of same and the Yardmaster reinstated and compensated for the difference between the amount he would have earned in service and amount he earned from outside employment during the period he was out of service.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2104"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-medical-disqualification-process",
  "rule": "ARTICLE 27 — JOINT MEDICAL BOARD",
  "quote": "(a) When a Yardmaster has been physically disqualified, he shall be furnished a copy of the medical report containing the reason for disqualification.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2346"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-neutral-physician-process",
  "rule": "ARTICLE 27 — JOINT MEDICAL BOARD",
  "quote": "The findings of the neutral physician shall be final and binding. If the neutral physician finds that the diagnosis of the Chief Medical Officer is not correct, the Yardmaster shall be returned to service promptly after the report is received by the Chief Medical Officer of the Carrier.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2350"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-precise-charge-and-notice",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "Such Yardmaster shall be apprised in writing of the precise charge against him, with copy to the General Chairman",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2092"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-right-to-a-hearing-before-discipline",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "(a) Yardmasters shall not be disciplined, disqualified subsequent to their being qualified, or dismissed without a fair and impartial hearing before a proper officer.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2092"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-transcript-furnishing",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "Stenographic report or transcript of tape recording will be taken of all hearings or investigations. The Yardmaster involved, Local Chairman and General Chairman shall each be furnished with one copy, within twenty (20) calendar days of completion of hearing.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2098"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-waiver-content",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "(i) If disposition of the charges is made on the basis of the Yardmaster's acknowledgment of responsibility, the disposition shall be reduced to writing and signed by the Yardmaster and the official involved and shall incorporate a waiver of hearing and shall specify the maximum discipline which may be imposed for Yardmaster's acceptance of responsibility.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2120"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-waiver-procedure",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "Prior to the Yardmaster signing a waiver, the General Chairman must be notified. If the waiver notification of the General Chairman creates a conflict with the time limits in this Article, the time limits will be extended to allow notification.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2118"
 },
 {
  "key": "CSX-2002",
  "id": "DISC-witnesses-and-representation",
  "rule": "ARTICLE 21 — DISCIPLINE",
  "quote": "He shall have reasonable opportunity to secure the presence of necessary witnesses and shall have the right to be represented by the duly accredited representative.",
  "cite": "data/agreements/csx-2002-system-agreement.source.txt:2092"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-appeal-limits",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "If the decision is not satisfactory to the employee or to the organization it may be",
  "cite": "data/agreements/dh-codified-2007.source.txt:1808"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-appeal-limits",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "and employment, until the decision on appeal is rendered. The carrier shall promptly",
  "cite": "data/agreements/dh-codified-2007.source.txt:1813"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-appeal-limits",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "unless the carrier and the organization agree otherwise in writing. The decision on appeal shall be final and binding",
  "cite": "data/agreements/dh-codified-2007.source.txt:1823"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-appeal-limits",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "such circumstances, the General Chairman must, within 60 days from the date the",
  "cite": "data/agreements/dh-codified-2007.source.txt:796"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-hearing-conduct-informal-handling",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "matter to their mutual interests. Request for informal handling must be made at least 24",
  "cite": "data/agreements/dh-codified-2007.source.txt:712"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-hearing-conduct",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "shall set a date for hearing which shall be held within ten calendar days of the date of",
  "cite": "data/agreements/dh-codified-2007.source.txt:1790"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-hearing-conduct",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "dismissed from the service until a fair and impartial formal investigation has been conducted by an authorized Carrier officer.",
  "cite": "data/agreements/dh-codified-2007.source.txt:685"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-hearing-conduct",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "desired witnesses who have knowledge of the act or occurrence, to present testimony, and the Carrier will order employee witnesses to be in attendance.",
  "cite": "data/agreements/dh-codified-2007.source.txt:754"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-hearing-conduct",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "pending the investigation and other principal(s) or witness(es) are not available for the reasons cited, he may request commencement of the investigation. If either the Yardmaster or the Carrier officer is of the opinion that the testimony of the unavailable principal(s) or witness(es) is necessary for the final determination of the facts and discipline has been assessed against the Yardmaster as a result of the investigation, such discipline will be reviewed when the testimony of the missing principal(s) or witness(es) is available.",
  "cite": "data/agreements/dh-codified-2007.source.txt:764"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-hearing-conduct",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "have the right to be present during the entire investigation. Witnesses appearing at",
  "cite": "data/agreements/dh-codified-2007.source.txt:774"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-hearing-conduct",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "Yardmaster subject to discipline and those witnesses testifying on his behalf.",
  "cite": "data/agreements/dh-codified-2007.source.txt:776"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "form of notice to be used shall be agreed upon by the individual railroad and the",
  "cite": "data/agreements/dh-codified-2007.source.txt:1779"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "conducted. A serious act or occurrence is defined as: Rule \"G\", Insubordination, Extreme Negligence, Dishonesty.",
  "cite": "data/agreements/dh-codified-2007.source.txt:691"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "resolved, no formal investigation will be required. A written notice of the discipline",
  "cite": "data/agreements/dh-codified-2007.source.txt:716"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "i) The time, date and location where the formal investigation will be held.",
  "cite": "data/agreements/dh-codified-2007.source.txt:732"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "ii) The date, approximate time and the location of the act or occurrence.",
  "cite": "data/agreements/dh-codified-2007.source.txt:734"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "iii) A description of the act or occurrence which is the subject of the investigation.",
  "cite": "data/agreements/dh-codified-2007.source.txt:736"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "v) The identity of the witnesses directed by the Carrier to attend.",
  "cite": "data/agreements/dh-codified-2007.source.txt:742"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-notice-charge-specificity",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "attend the formal investigation, the Yardmaster will be furnished a copy of the written complaint together with the written notice for him to attend the investigation.",
  "cite": "data/agreements/dh-codified-2007.source.txt:746"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-record-removal-informal-handling-record",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "statement or recording will be taken at the informal handling. When a case is handled",
  "cite": "data/agreements/dh-codified-2007.source.txt:714"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-record-removal-transcript-form",
  "rule": "RULE — APPENDIX 8, LETTER NO. 1 — DISCIPLINE RECORD",
  "quote": "is understood that the phrase \"a true copy of the investigation record\" will mean a stenographic",
  "cite": "data/agreements/dh-codified-2007.source.txt:3852"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-record-removal-transcript-furnishing",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "given to the Yardmaster and to his duly accredited representative.",
  "cite": "data/agreements/dh-codified-2007.source.txt:782"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-record-removal",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "(e) Provisions of investigation and discipline rules contained in the Rules and Working",
  "cite": "data/agreements/dh-codified-2007.source.txt:1861"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-representation-performance-development-plan",
  "rule": "RULE — APPENDIX 9, LETTER OF UNDERSTANDING NO. 2",
  "quote": "The parties agree that if performance gaps are noted in the regular performance feedback",
  "cite": "data/agreements/dh-codified-2007.source.txt:4610"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-representation",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "employee in writing with copy to the organization, by Registered Mail, Return Receipt",
  "cite": "data/agreements/dh-codified-2007.source.txt:1792"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-representation",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "copy to the Local Chairman, if he participated in the informal handling, at the",
  "cite": "data/agreements/dh-codified-2007.source.txt:718"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-representation",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "iv) A statement that he may be represented by his duly accredited representative of",
  "cite": "data/agreements/dh-codified-2007.source.txt:738"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "organizations involved and the form shall make provision for specifying the reasons for",
  "cite": "data/agreements/dh-codified-2007.source.txt:1780"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "request for a hearing shall operate to stay action on the termination of employment until",
  "cite": "data/agreements/dh-codified-2007.source.txt:1795"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "(b) The carrier shall determine on the basis of the evidence produced at the hearing whether",
  "cite": "data/agreements/dh-codified-2007.source.txt:1800"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — APPENDIX 2 — UNION SHOP",
  "quote": "(g) In computing the time periods specified in this agreement, the date on which a notice is",
  "cite": "data/agreements/dh-codified-2007.source.txt:1869"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "writing within 10 days from the date of the act or occurrence or in cases involving",
  "cite": "data/agreements/dh-codified-2007.source.txt:725"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "dishonesty, criminal offences, or letters of complaint, within 10 days from the",
  "cite": "data/agreements/dh-codified-2007.source.txt:726"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "(c) The investigation on any matter must be scheduled to begin within 10 days",
  "cite": "data/agreements/dh-codified-2007.source.txt:748"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "witness(es) to attend the formal investigation and may, by written notice to the Yardmaster involved, be extended by the equivalent amount of time the",
  "cite": "data/agreements/dh-codified-2007.source.txt:758"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "as set forth in this rule, no discipline will be assessed against the Yardmaster.",
  "cite": "data/agreements/dh-codified-2007.source.txt:770"
 },
 {
  "key": "DH-CP-2007",
  "id": "DISC-time-limits",
  "rule": "RULE — ARTICLE 13 — DISCIPLINE AND INVESTIGATION",
  "quote": "disciplined will be given a written notice of the decision within 21 days of the date the formal investigation is completed.",
  "cite": "data/agreements/dh-codified-2007.source.txt:788"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-appeal-limits",
  "rule": "RULE 23 — TIME LIMIT - GRIEVANCES (as amended 2026-08-04)",
  "quote": "If a disallowed claim or grievance is to be appealed, including appeals of disciplinary decisions, such appeal must be taken within sixty (60) calendar days from receipt of notice of disallowance, or Notice of Discipline in disciplinary cases.",
  "cite": "data/agreements/metra-nirc-ym-letter-2026-08-04-rule23b.source.txt:15"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-decision-time-limit",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS (as amended 2014-08-27)",
  "quote": "Within ten (10) days thereafter, an investigation shall be held, and a decision shall be rendered within ten (10) days after the investigation.",
  "cite": "data/agreements/metra-nirc-ym-wrb-2014-08-27.source.txt:137"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct-cross-examination",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Only one of such representatives shall have the right to interrogate witnesses.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:733"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct-cross-examination",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "in cases where the guilt of the accused is not proven beyond a reasonable doubt by the other witnesses present at the investigation, no discipline will be assessed.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:739"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct-cross-examination",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Exception to this section (f) may be made where it is shown that a certain employee has been consistently reported for improper conduct in the performance of his duties.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:745"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct-cross-examination",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Neither the officer conducting the investigation nor reviewing agencies may consider evidence not obtained in accordance with section (f) of this Rule.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:771"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct-right-to-hearing",
  "rule": "RULE 21 — UNJUST TREATMENT",
  "quote": "An employee who considers himself otherwise unjustly treated will have the same right of investigation and appeal as provided in this Agreement, if written request is filed with the Carrier within twenty (20) days from cause of complaint.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:795"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Investigations wi ll not be conducted for more than six (6) hours in a calendar day exclusive of short recesses which will be granted.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:761"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "The contents of the investigation transcript will be the basis for assessing discipline.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:770"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-conduct",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "If discipline is assessed , the Carrier's findings as to guilt and its explanation thereof will be based on the contents of the investigation transcript.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:776"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-hearing-time-limit",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS (as amended 2014-08-27)",
  "quote": "Within ten (10) days thereafter, an investigation shall be held, and a decision shall be rendered within ten (10) days after the investigation.",
  "cite": "data/agreements/metra-nirc-ym-wrb-2014-08-27.source.txt:137"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-improper-withholding-from-service",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "an employee will not be held out of service priorto a fair and impartial investigation and subsequent written decision as provided by this Article,",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:700"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-just-cause",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "If the testimony adduced at the investigation fails to sustain the specific charges which were preferred , the employee under investigation shall be exonerated.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:772"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-make-whole-on-exoneration",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "In case the suspension, dismissal, or record entry is found to be unjust, the employee involved shall have the entry removed from the record and, if suspended or dismissed, he shall be reinstated and paid for all time lost.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:779"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-precise-charge-and-notice",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "When charges are made against any employee, they shall be put in writing, be specific and convey clearly to the accused the nature of the offense of which he is charged.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:687"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-precise-charge-and-notice",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "There shall be no citation of rules in the investigation notice.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:689"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-precise-charge-and-notice",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "It shall be the obligation of the Carrier to deliver said written notice of investigation to the accused by U.S. Mail or by Carrier's own messenger. Telephone messages are not acceptable under this Rule.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:690"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-record-removal-transcript-form",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "True and correct stenographic records will be taken at all investigations held under this Article",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:748"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-record-removal-transcript-form",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Objections and the reasons therefore as well as the conducting officer's response the reto will be recorded in the transcript of investigation at the time they are made.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:758"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-representation",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Employees shall have the right to be present and represented at investigations with one or more duly accredited representatives of the United Transportation Union - Yardmasters, who shall have the right to hear all oral and read all written testimony, and to bring out any facts in connection with the case.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:730"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-right-to-a-hearing-before-discipline",
  "rule": "RULE 6 — SENIORITY, ESTABLISHMENT OF",
  "quote": "A ya rdmaster shall not thereafter be disqualified for such service. except as provided in Rule 20 - Discipline Investigations of this Agreement.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:369"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-time-limits-appeal-decisions",
  "rule": "RULE 23 — TIME LIMIT - GRIEVANCES (as amended 2026-08-04)",
  "quote": "The Carrier will then have sixty (60) days to respond to the Organization’s appeal.",
  "cite": "data/agreements/metra-nirc-ym-letter-2026-08-04-rule23b.source.txt:18"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-time-limits",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS (as amended 2014-08-27)",
  "quote": "Employees continued in service or not censured pending an investigation of an alleged offense shall be notified within ten (10) days after a Carrier Officer having authority to order an investigation has information of the offense of the charges pending.",
  "cite": "data/agreements/metra-nirc-ym-wrb-2014-08-27.source.txt:134"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-transcript-furnishing",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "a complete transcript of all proceedings in all cases shall be given to the representative upon request.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:749"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-unreasonable-refusal-of-extension",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Recess of the investigation will be granted unless it is obvious that the request for the recess is only made for the purpose of delaying the investigation.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:724"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-unreasonable-refusal-of-extension",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Where the employee charged or a material witness is unable to attend because of sickness or injury, the investigation may be deferred until such time as the employee charged or material witness is able to attend the investigation.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:725"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-unreasonable-refusal-of-extension",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "A reasonable postponement will be granted when necessary to arrange for a representative of the employee's choice.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:767"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-witnesses-and-representation",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "The Carrier will arrange to have present as witnesses those employees who are known or can reasonably be expected to know facts material to the subject matter",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:715"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-witnesses-and-representation",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "The Carrier will notify any employee whom the man under charge or his representative desires as witnesses.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:719"
 },
 {
  "key": "METRA-NIRC-YM-1984",
  "id": "DISC-witnesses-and-representation",
  "rule": "RULE 20 — DISCIPLINE - INVESTIGATIONS",
  "quote": "In the event that it develops, during the course of the investigation, that there are employees who have knowledge oftacts material to the subject under investigation who are not present. the employee charged or his representative may make request for such witnesses, stating what is expected to be developed from their testimony.",
  "cite": "data/agreements/metra-nirc-ym-1984-rev2010.source.txt:720"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-decision-time-limit",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Within seven days thereafter, an investigation shall be held, and a decision shall be rendered within ten days after the investigation.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1563"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-hearing-conduct-cross-examination",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Only one of such representatives shall have the right to interrogate witnesses.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1613"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-hearing-conduct-cross-examination",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Except as to records or documents or copies thereof which have been notarized, no oral or written statements or testimony taken at any time or place other than during the investigation will be recorded in the transcript, nor will it be considered as evidence by reviewing agencies, unless the person or persons, making such oral or written statement is present at the investigation to testify that the statement made is his",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1617"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-hearing-conduct",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Objections and the reasons therefore will be recorded in the transcript. The officer conducting the investigation will render a ruling and the reason therefore on the objection at the time.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1646"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-hearing-conduct",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Investigations will not be conducted for more than six (6) hours in a calendar day exclusive of short recesses which will be granted.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1651"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-hearing-conduct",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "The contents of the investigation transcript will be the basis for assessing discipline. Neither the officer conducting the investigation nor reviewing agencies may consider evidence not obtained in accordance with Paragraph (g) of this Article.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1661"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-hearing-time-limit",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Within seven days thereafter, an investigation shall be held, and a decision shall be rendered within ten days after the investigation.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1563"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-holding-out-of-service",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Any suspension assessed against an employee shall be regarded as effective from the first day held out of service.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1678"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-improper-withholding-from-service",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Except as herein provided, an employee will not be held out of service prior to a fair and impartial investigation and subsequent written decision as provided by this Article, except for the following causes:",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1567"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-investigation-outside-assigned-hours",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "When possible, efforts will be made to hold investigations at a time and place which will be convenient for the man involved.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1655"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-just-cause",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "If the testimony adduced at the investigation fails to sustain the specific charges which were preferred, the employee under investigation shall be exonerated.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1664"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-just-cause",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "If discipline is assessed a reasonable explanation will be given based on the contents of the investigation transcript.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1669"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-make-whole-on-exoneration",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "In case the suspension, dismissal, or record entry is found to be unjust, the employee involved shall have the entry removed from his record and, if suspended or dismissed, he shall be reinstated and paid for all time lost.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1673"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-notice-charge-specificity",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "When charges are made against any employee, they shall be put in writing, conveying clearly to the accused the nature of the offense of which he is charged.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1545"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-precise-charge-and-notice",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "There shall be no citation of rules in the investigation notice.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1547"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-precise-charge-and-notice",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "It shall be the obligation of the Company to deliver the said written notice of investigation to the accused either by U.S. Mail or by the Company’s own messenger. Telephone messages are not acceptable under this Article.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1547"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-record-removal-reinstatement",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "In case the suspension, dismissal, or record entry is found to be unjust, the employee involved shall have the entry removed from his record and, if suspended or dismissed, he shall be reinstated and paid for all time lost.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1673"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-record-removal-transcript-form",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "True and correct stenographic records will be taken at all investigations held under this Article and a complete transcript of all proceedings in all cases shall be given to the representative upon request.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1627"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-representation",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Employees shall have the right to be present and represented at investigations with one or more duly accredited representatives of the UTU-Y, who shall have the right to hear all oral and read all written testimony, and to bring out any facts in connection with the case.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1610"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-right-to-a-hearing-before-discipline",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Except as herein provided, an employee will not be held out of service prior to a fair and impartial investigation and subsequent written decision as provided by this Article, except for the following causes:",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1567"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-right-to-a-hearing-before-discipline",
  "rule": "ARTICLE 7 — SENIORITY, ESTABLISHMENT OF",
  "quote": "A yardmaster shall not thereafter be disqualified for such service, accept as provided in Article 23 - Discipline Investigations of this Agreement.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:842"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-time-limits",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Employees continued in service or not censured pending an investigation of an alleged offense shall be notified within seven days after a Company Officer having authority to order an investigation has information of the offense of the charges pending.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1560"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-transcript-furnishing",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "True and correct stenographic records will be taken at all investigations held under this Article and a complete transcript of all proceedings in all cases shall be given to the representative upon request.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1627"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-transcript",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "The General Chairman of the UTU-Y may have his own stenographer at any investigation if he so desires.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1629"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-unreasonable-refusal-of-extension",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Recess of the investigation will be granted unless it is obvious that the request for the recess is only made for the purpose of delaying the investigation.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1602"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-unreasonable-refusal-of-extension",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "Where the employee charged or a material witness is unable to attend because of sickness or injury, the investigation may be deferred until such time as the employee charged or material witness is able to attend the investigation.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1604"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-unreasonable-refusal-of-extension",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "A reasonable postponement will be granted when necessary to arrange for a representative of the employee's choice.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1656"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-witnesses-and-representation",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "The Company will arrange to have present as witnesses those employees who are known or can reasonably be expected to know facts material to the subject matter of the investigation.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1594"
 },
 {
  "key": "SOO-YM-2005-11-01",
  "id": "DISC-witnesses-and-representation",
  "rule": "ARTICLE 23 — DISCIPLINE - INVESTIGATIONS",
  "quote": "The Company will notify any employee whom the man under charge or his representative desires as witnesses.",
  "cite": "data/agreements/soo-ym-2005-11-01.source.txt:1596"
 }
];
